const getEnvironmentVariable = (environmentVariable: string, isOptional = false): string => {
  const value = import.meta.env[environmentVariable] as string | undefined;

  if (!value && !isOptional) {
    throw new Error(`Couldn't find environment variable: ${environmentVariable}`);
  }

  return typeof value === 'string' ? value : '';
};

const config = {
  ccpInstanceURL: getEnvironmentVariable('VITE_CCP_INSTANCE_URL'),
  cppSamURL: getEnvironmentVariable('VITE_SAML_URL'),
  cassieWebsocketURL: getEnvironmentVariable('VITE_CASSIE_WS_URL'),
  cassieWebsocketProtocol: getEnvironmentVariable('VITE_CASSIE_PROTOCOL'),
  title: getEnvironmentVariable('VITE_TITLE'),
  region: getEnvironmentVariable('VITE_REGION'),
  environment: getEnvironmentVariable('VITE_ENV', true),
  catoApiUrl: getEnvironmentVariable('VITE_CATO_API_URL', true),
  emailApiUrl: getEnvironmentVariable('VITE_EMAIL_API_URL', true),
  emailContactFlowId: getEnvironmentVariable('VITE_EMAIL_CONTACT_FLOW_ID', true),
  chatApiAuthUrl: getEnvironmentVariable('VITE_CHAT_AUTH_URL', true),
  chatApiUrl: getEnvironmentVariable('VITE_CHAT_API_URL', true),
  chatApiAuthUsername: getEnvironmentVariable('VITE_CHAT_AUTH_USERNAME', true),
  chatApiAuthPassword: getEnvironmentVariable('VITE_CHAT_AUTH_PASSWORD', true),
  datadogClientToken: getEnvironmentVariable('VITE_DATADOG_CLIENT_TOKEN', true),
  datadogRumClientToken: getEnvironmentVariable('VITE_DATADOG_RUM_CLIENT_TOKEN', true),
  datadogEnv: getEnvironmentVariable('VITE_DATADOG_ENV', true),
};

export default config;
